import type {
  BoardModelDebugMeasurable,
  BoardModelDebugMeasureContext,
} from "./measurable";
import {
  ensureBoardModelDebugLabelHost,
  stripLegacyFrameLabel,
  syncBoardModelDebugLabel,
} from "./labelHost";
import { resolveBoardModelDebugLabelPlacement } from "./labelPlacement";
import { insetDebugBounds } from "./ringLayout";
import { applyDebugFrame } from "./bounds";

export function applyBoardModelDebugMeasurable(
  frame: HTMLElement,
  measurable: BoardModelDebugMeasurable,
  context: BoardModelDebugMeasureContext,
): void {
  stripLegacyFrameLabel(frame);
  const measured = measurable.measure(context);
  const box = measured === null
    ? null
    : insetDebugBounds(measurable.kind, measured);
  applyDebugFrame(frame, box);
  const placement = resolveBoardModelDebugLabelPlacement(measurable);
  const labelHost = context.labelHost ?? ensureBoardModelDebugLabelHost(context.world);
  syncBoardModelDebugLabel(
    labelHost,
    measurable.kind,
    measurable.debugId,
    box,
    placement,
  );
}
